import { render, staticRenderFns } from "./VuetifySurvey.vue?vue&type=template&id=72f770ac"
import script from "./VuetifySurvey.vue?vue&type=script&lang=js"
export * from "./VuetifySurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports